module.exports = __webpack_public_path__ + "static/media/obxLogoBig.28d02189.png";